
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));
const CerezPolitikasiPage = lazy(() => import('../pages/cerez-politikasi/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  {
    path: '/cerez-politikasi',
    element: <CerezPolitikasiPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
